var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVisa = function SvgVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.953.208 13.07 11.801h3.012L17.965.208h-3.012Zm-4.418 0L7.662 8.181l-.339-1.717-.075-.384a9.6 9.6 0 0 0-2.673-3.394 11.96 11.96 0 0 0-1.34-.93L5.844 11.8h3.14L13.776.208h-3.243Zm11.758 3.218c0-1.31 2.934-1.142 4.224-.43l.43-2.49S25.62 0 24.237 0c-1.495 0-5.046.655-5.046 3.838 0 2.995 4.167 3.032 4.167 4.605 0 1.573-3.737 1.292-4.97.3l-.45 2.602S19.285 12 21.34 12s5.157-1.067 5.157-3.969-4.204-3.295-4.204-4.605ZM34.588.208h-2.422c-1.12 0-1.391.864-1.391.864l-4.493 10.729h3.14l.628-1.722h3.83l.354 1.722H37L34.588.208ZM30.918 7.7 32.5 3.362l.89 4.338h-2.473Z",
    fill: "#005BAC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.35 1.3S6.225.254 4.894.254H.057L0 .451s2.325.475 4.556 2.253c2.131 1.7 2.827 3.82 2.827 3.82L6.35 1.3V1.3Z",
    fill: "#F6AC1D"
  })));
};
export default SvgVisa;